//import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Nav from "./components/nav/Nav";
import Experience from "./components/experience/Experience";
import Portfolio from "./components/portfolio/Portfolio";
import Services from "./components/services/Services";
import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";

//ِAnimation library
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import About from "./components/about/About";
AOS.init();

function App() {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Portfolio />
      <Services />

      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
